// extracted by mini-css-extract-plugin
export default {"zoomModal":"b2-z"};